import React, { Component } from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import Typography from 'typography'

import MainMenu from '../components/MainMenu'

import ScrollPercentageTracking from '../components/Tracking/ScrollPercentageTracking'

import get from 'lodash/get'

import './index.css'
require("prismjs/themes/prism-tomorrow.css");

class TemplateWrapper extends Component {
  static propTypes = {
    children: PropTypes.func,
  }

  static childContextTypes = {
    staticData: PropTypes.array
  };

  getChildContext() {
    return {
      staticData: get(this.props, 'data.allContentfulContentZone.edges')
    }
  }

  render () {
    const {
      location,
    } = this.props
    
    return (<ScrollPercentageTracking location={location}>
      <Helmet
        title="Atrakeur: Web et DIY" />
        
      <MainMenu />
      { this.props.children() } 
    </ScrollPercentageTracking>)
  }
}

export default TemplateWrapper

export const pageQuery = graphql`
query StaticData {
  allContentfulContentZone {
    edges {
      node {
        contentfulid
        contentImage {
          id
          file {
            url
            fileName
            contentType
          }
          title
          description
          resolutions(width: 2048) {
            ...GatsbyContentfulResolutions
          }
        }
        contentText {
          id
          contentText
          childMarkdownRemark {
            html
          }
        }
      }
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/layouts/index.js